import { useState } from 'react'
import { useNavigate, Link as RouterLink } from 'react-router-dom'
import { Eye, EyeOff, Loader2 } from 'lucide-react'
import { useAuthStore } from '@/store/authStore'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Card } from '@/components/ui/card'
import { Alert, AlertDescription } from '@/components/ui/alert'

export default function Login() {
  const navigate = useNavigate()
  const { login, isLoading, error } = useAuthStore()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    const success = await login(email, password)
    // Cada tipo de partner tiene su portada (el asesor cd-2b, /inicio): la decide DefaultRedirect.
    if (success) navigate('/')
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4 py-8 pt-safe pb-safe">
      <div className="w-full max-w-md">
        <Card className="p-6 sm:p-8 shadow-md">
          {/* Logo */}
          <div className="text-center mb-6">
            <div className="inline-flex h-14 w-14 items-center justify-center rounded-md bg-primary text-primary-foreground font-display text-h3 font-semibold mb-3">
              CD
            </div>
            <h1 className="font-display text-h1 font-semibold text-foreground leading-tight">
              Portal de Partners
            </h1>
            <p className="text-body-sm text-subtle mt-1">
              Ingresa con tu cuenta de partner
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="login-email">Correo electrónico</Label>
              <Input
                id="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                autoComplete="email"
                placeholder="tu@email.com"
              />
            </div>

            <div className="space-y-1.5">
              <Label htmlFor="login-password">Contraseña</Label>
              <div className="relative">
                <Input
                  id="login-password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                  className="pr-12"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex h-10 w-10 items-center justify-center rounded-md text-subtle hover:bg-surface-muted hover:text-foreground transition-colors"
                  aria-label={showPassword ? 'Ocultar' : 'Mostrar'}
                >
                  {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            {error && (
              <Alert variant="destructive">
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}

            <Button type="submit" size="cta" disabled={isLoading}>
              {isLoading ? (
                <>
                  <Loader2 size={18} className="animate-spin" />
                  Iniciando…
                </>
              ) : (
                'Iniciar sesión'
              )}
            </Button>

            <div className="text-center">
              <RouterLink
                to="/forgot-password"
                className="text-body-sm text-primary hover:underline"
              >
                ¿Olvidaste tu contraseña?
              </RouterLink>
            </div>
          </form>

          <div className="mt-6 pt-6 border-t border-line text-center">
            <p className="text-caption text-subtle">
              ¿No eres partner?{' '}
              <RouterLink to="/apply" className="text-primary font-medium hover:underline">
                Únete al programa
              </RouterLink>
            </p>
          </div>
        </Card>

        <p className="mt-4 text-center text-caption text-subtle">
          © {new Date().getFullYear()} CoreDesk. Todos los derechos reservados.
        </p>
      </div>
    </div>
  )
}
